import { useState, useEffect, useRef } from "react"
import QrScanner from "qr-scanner"

import Style from "./style"

import useGetParticipationState from "entity/event/useGetParticipationState"

const QR = () => {
    const [isQrError, setIsQrError] = useState(false)
    const cameraRef = useRef()

    const [postParticipationState] = useGetParticipationState()

    // ===== QR Code =========================

    const options = {
        preferredCamera: "environment",   // 핸드폰의 경우 외부 카메라, 셀프 카메라 여부
        maxScansPerSecond: 2,    // 1초에 2번 QR 코드 감지한다.
    }

    useEffect(() => {
        let qrScanner = null
        QrScanner.hasCamera()
            .then((hasCamera) => {
                if (!hasCamera) {
                    setIsQrError(true)   // 보통 카메라가 없을 때 발생
                } else {
                    const camera = cameraRef.current
                    if (camera) {
                        qrScanner = new QrScanner(camera, (result) => postParticipationState(result), options)
                        qrScanner.start().catch(e => setIsQrError(true))   // 보통 카메라 권한이 없을 때 발생
                    }
                }
            })
        return () => {
            if (qrScanner) qrScanner.destroy()
        }
    }, [])

    // ========================================

    return (
        <Style.Wrapper>
            {isQrError
                ?
                <Style.ErrorDiv>
                    <h2>카메라를 실행할 수 없습니다.</h2>
                    <div>
                        <p>카메라 권한이 허용되어있지 않습니다.</p>
                        <p>카메라가 연결되어있지 않은 기기입니다.</p>
                    </div>
                </Style.ErrorDiv>
                :
                <>
                    <Style.Video ref={cameraRef} />
                    <Style.Content>
                        <Style.ScanDiv />
                        <Style.ExplainDiv>
                            <p>대회 참가 / 대회 탈락</p>
                            <h2>QR 코드를 스캔하세요</h2>
                        </Style.ExplainDiv>
                    </Style.Content>
                </>
            }

        </Style.Wrapper>
    )
}

export default QR